import nl from "./dutch.json";
import en from "./english.json";
import fr from "./french.json";
import de from "./german.json";
import ja from "./japanese.json";
import ko from "./korean.json";
import zh from "./mandarin.json";
import pt from "./portuguese.json";
import es from "./spanish.json";

export { de, en, es, fr, ja, ko, nl, pt, zh };
